/* Built In Imports */
import { useState } from 'react';

/* External Imports */
import { Box, Button, Radio, RadioGroup, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { refineUrlDomain } from '@components/Utility/utils';
import config from '@config';
import { useEOEContext } from '@store/EOEContext';
import NoSeatingAvailable from '@landing_pages/eoe/components/NoSeatingAvailable';

/* Service */
import { searchByFieldId } from '@components/Utility/Shared/SharedService';

/**
 *
 * @param {Object} sectionContent
 * @returns
 */
export const EnlightenmentFourRow = ({
  sectionContent,
  region,
  lang,
  pageData,
  listTicket,
  setListTicket,
  isCityClicked,
  selTab,
}) => {
  const { city, isIeDone, isIeMode, ieLang, cityName } = useEOEContext();
  const [tokenId, setTokenId] = useState('');

  const listEventTicketRow = index => {
    const ticket = listTicket?.tickets?.[index];
    if (!ticket) return null;
    const { name, json_pricing } = ticket;
    let price = json_pricing?.base?.original_price;
    let discountedPrice = json_pricing?.base?.price;

    if (!isIeDone) {
      price =
        json_pricing?.base?.original_price +
        (ieLang === 'en'
          ? json_pricing?.english_price?.original_price
          : json_pricing?.vernacular_price?.original_price);
      discountedPrice =
        json_pricing?.base?.price +
        (ieLang === 'en'
          ? json_pricing?.english_price?.price
          : json_pricing?.vernacular_price?.price);
    }

    const getColorForIndex = index => {
      switch (index) {
        case 1:
          return '#185171';
        case 2:
          return '#0E3F4F';
        case 3:
          return '#0E3F3C';
        case 4:
          return '#5E4310';
        default:
          return 'inherit';
      }
    };

    let InrRupees = new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
    });

    return (
      <>
        <Box
          height={{ base: '52px', md: '80px' }}
          w={{ base: '70%', md: '266px' }}
          mx="auto"
          boxSizing="content-box"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          border={
            index == 0 ? '10px solid #fff' : index == 1 && '10px solid #fff'
          }
          borderTop="0"
        >
          <Box
            key={index}
            display="flex"
            alignItems="center"
            justifyContent={
              ticket?.seats_available ? 'space-between' : 'center'
            }
            w="full"
            px="15px"
          >
            {ticket?.seats_available > 0 && (
              <>
                {name && (
                  <RadioGroup
                    onChange={setTokenId}
                    value={tokenId}
                    size="lg"
                    name={name}
                  >
                    <Radio
                      value={ticket?.token}
                      // key={nanoid(2)}
                      isInvalid
                      bg="white"
                      border="1px solid"
                      _checked={{
                        background: '#CF4520',
                        border: '2px solid #fff',
                        outline: '4px solid #fff',
                        outlineOffset: '-5px',
                      }}
                    >
                      <Box
                        fontFamily="'FedraSansStd-medium'"
                        fontSize={{ base: '12px', md: '14px' }}
                      >
                        {name}
                      </Box>
                    </Radio>
                  </RadioGroup>
                )}
              </>
            )}
            <Box
              display="flex"
              flexDir="column"
              fontSize={{ base: '10px', md: '12px' }}
              fontFamily="'FedraSansStd-book'"
            >
              {price > 0 && (
                <>
                  <Text fontFamily="'FedraSansStd-medium'" textAlign="right">
                    {InrRupees.format(discountedPrice)
                      .replace('₹', 'INR ')
                      .replace('.00', '')}
                  </Text>
                  {discountedPrice != price && (
                    <Text
                      as="del"
                      fontFamily="'FedraSansStd-medium'"
                      color={getColorForIndex(index)}
                      textAlign="right"
                    >
                      {InrRupees.format(price)
                        .replace('₹', 'INR ')
                        .replace('.00', '')}
                    </Text>
                  )}
                </>
              )}
              {price <= 0 && (
                <>
                  <Text fontFamily="'FedraSansStd-medium'" textAlign="right">
                    Free seating
                  </Text>
                </>
              )}
            </Box>

            {name && !ticket?.seats_available ? (
              <NoSeatingAvailable
                name={name}
                price={price}
                discountedPrice={discountedPrice}
              />
            ) : (
              <></>
            )}
          </Box>
        </Box>
        {price <= 0 && (
          <Box display="flex" pb="10px">
            (Donate as you wish)
          </Box>
        )}
      </>
    );
  };

  const gtmClick = () => {
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push({
        event: 'EoE_Register_Now',
        IE_status: isIeDone ? 'Yes' : 'No',
        IE_Lang: isIeDone ? 'en' : ieLang,
        city: cityName,
      });

      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          currency: '',
          value: '',
          items: [
            {
              item_id: city, // id of the program
              item_name:
                cityName?.toLowerCase() === 'chennai'
                  ? 'Sadhguruvudan Gyanam Dhyanam Anandham'
                  : 'Ecstasy of Enlightenment', // Name of the program (Ex - EoE)
              affiliation: '',
              coupon: '',
              discount: '',
              index: '',
              item_brand: isIeDone ? 'Yes' : 'No', //IE Status <Yes/No>
              item_category: ieLang, //IE Lang (User selected IE Language Ex- MR,EN,HI)
              item_category2: '',
              item_category3: '',
              item_category4: '',
              item_category5: '',
              item_list_id: '',
              item_list_name: '',
              item_variant: '',
              location_id: cityName,
              price: '',
              quantity: '',
            },
          ],
        },
      });
    }
  };

  if (isCityClicked && !city) {
    return <></>;
  }

  return (
    <Box
      display="flex"
      flexDir="column"
      alignItems="center"
      bg="#fff"
      opacity={city ?? 0.2}
      pointerEvents={city ?? 'none'}
    >
      {searchByFieldId(sectionContent, 'yes-dias') && (
        <Box
          bg="#DEB58E"
          px="50px"
          py="12px"
          fontSize="20px"
          borderRadius="9px"
          fontFamily="FedraSansStd-medium"
        >
          {searchByFieldId(sectionContent, 'yes-dias').text}
        </Box>
      )}
      {searchByFieldId(sectionContent, 'yes-sel-cat') && (
        <Box
          fontSize="16px"
          fontStyle="italic"
          fontFamily="FedraSansStd-medium"
          py="20px"
          px="15px"
          textAlign="center"
        >
          {searchByFieldId(sectionContent, 'yes-sel-cat').text}
        </Box>
      )}
      <Box
        className="mainLayout"
        w={{ base: '100%', sm: '390px', md: 'unset' }}
      >
        <Box
          bg={
            !listTicket?.tickets[0]?.seats_available
              ? '#C6C6C6'
              : tokenId == listTicket?.tickets[0].token
              ? '#2c2459'
              : '#807c9c'
          }
          color={
            !listTicket?.tickets[0]?.seats_available
              ? '#6A6A6A'
              : tokenId == listTicket?.tickets[0].token && '#fff'
          }
          boxSizing="border-box"
          height="auto"
          w={{ base: '100%', md: '286px' }}
          mx="auto"
          as="label"
          cursor="pointer"
          position="absolute"
          zIndex={1}
          top="0px"
          transform={{ base: 'translate(0%, 0%)', md: 'translate(19%, 0%)' }}
          _hover={{ background: ' #2c2459', color: '#fff' }}
        >
          {listEventTicketRow(0)}
        </Box>

        <Box
          bg={
            !listTicket?.tickets[1]?.seats_available
              ? '#C6C6C6'
              : tokenId == listTicket?.tickets[0].token
              ? '#176F9F'
              : '#74a9c5'
          }
          color={
            !listTicket?.tickets[1]?.seats_available
              ? '#6A6A6A'
              : tokenId == listTicket?.tickets[0].token && '#fff'
          }
          boxSizing="border-box"
          height="auto"
          w={{ base: '100%', md: '286px' }}
          mx="auto"
          as="label"
          cursor="pointer"
          position="absolute"
          zIndex={1}
          top={{ base: '62px', md: '90px' }}
          transform={{ base: 'translate(0%, 0%)', md: 'translate(19%, 0%)' }}
          _hover={{ background: '#176F9F', color: '#fff' }}
        >
          {listEventTicketRow(1)}
        </Box>
        <Box
          bg={
            !listTicket?.tickets[2]?.seats_available
              ? '#C6C6C6'
              : tokenId == listTicket?.tickets[0].token
              ? '#376F81'
              : '#739aa7'
          }
          color={
            !listTicket?.tickets[2]?.seats_available
              ? '#6A6A6A'
              : tokenId == listTicket?.tickets[0].token && '#fff'
          }
          borderBottom="10px solid #fff"
          boxSizing="border-box"
          height="auto"
          w={{ base: '100%', md: '396px' }}
          borderRadius="12px 12px 0px  0px"
          mx="auto"
          pt={{ base: '130px', md: '180px' }}
          as="label"
          cursor="pointer"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          position="relative"
          _hover={{ background: '#376F81', color: '#fff' }}
        >
          {listEventTicketRow(2)}
        </Box>

        <Box
          bg={
            !listTicket?.tickets[3]?.seats_available
              ? '#C6C6C6'
              : tokenId == listTicket?.tickets[0].token
              ? '#A68341'
              : '#c1a87a'
          }
          color={
            !listTicket?.tickets[3]?.seats_available
              ? '#6A6A6A'
              : tokenId == listTicket?.tickets[0].token && '#fff'
          }
          height={{ base: '92px', md: '120px' }}
          borderRadius="0 0 12px 12px "
          boxSizing="border-box"
          w={{ base: '100%', md: '396px' }}
          as="label"
          cursor="pointer"
          display="flex"
          alignItems="center"
          flexDirection="column"
          _hover={{ background: '#A68341', color: '#fff' }}
        >
          {listEventTicketRow(3)}
          {/* <Box display="flex" alignItems="center" w="full">
            {listEventTicketRow(3)}
          </Box>
          <Box display="flex" pb="10px">
            (Donate as you wish)
          </Box> */}
        </Box>
      </Box>

      <Box py="40px">
        {sectionContent[28]?.buttonText && (
          <Button
            disabled={!tokenId}
            fontFamily="FedraSansStd-medium"
            fontWeight="400"
            color="#faf7f0"
            fontSize={{ base: '14px', md: '18px' }}
            opacity={tokenId ? '1' : '0.4'}
            cursor={tokenId ? 'pointer' : 'not-allowed'}
            background={tokenId ? '#CF4520' : '#333333'}
            _hover={{
              background: tokenId ? '#000054' : '#333333',
            }}
            onClick={() => {
              if (tokenId) {
                gtmClick();
                window.open(
                  refineUrlDomain(
                    `${config.EOE_EVENT_DOMAIN}/event/${city}/register?iso_ie_done=${isIeDone}&iso_ie_mode=${isIeMode}&iso_ie_lang=${ieLang}&iso_ticket_id=${tokenId}&iso_country_code=${pageData?.country}`
                  ),
                  '_blank'
                );
              }
            }}
          >
            {sectionContent[28]?.buttonText}
          </Button>
        )}
      </Box>
      {!selTab && (
        <Box maxW="498px">
          {searchByFieldId(sectionContent, 'no-text-1') && (
            <StructuredTextParser
              str={render(searchByFieldId(sectionContent, 'no-text-1').body)}
              region={region}
              lang={lang}
              fontFamily="FedraSansStd-book"
              fontStyle="italic"
              pb="20px"
              px="15px"
              mt="0"
            />
          )}

          {isIeDone && searchByFieldId(sectionContent, 'yes-price-include') && (
            <Box
              fontSize="16px"
              fontStyle="italic"
              fontFamily="FedraSansStd-book"
              py="5px"
              color="#303030"
              px="15px"
            >
              {searchByFieldId(sectionContent, 'yes-price-include').text}
            </Box>
          )}
          {!isIeDone && searchByFieldId(sectionContent, 'no-price-include') && (
            <Box
              fontSize="16px"
              fontStyle="italic"
              fontFamily="FedraSansStd-book"
              py="5px"
              color="#303030"
              px="15px"
            >
              {searchByFieldId(sectionContent, 'no-price-include').text}
            </Box>
          )}

          {searchByFieldId(sectionContent, 'note-text') && (
            <StructuredTextParser
              str={render(searchByFieldId(sectionContent, 'note-text').body)}
              region={region}
              lang={lang}
              fontFamily="FedraSansStd-book"
              pb="5px"
              fontSize="16px"
              color="#303030"
              mt="0px"
              px="15px"
              fontStyle="italic"
              className="pStrong"
            />
          )}
        </Box>
      )}
      <style jsx global>
        {`
          .mainLayout {
            font-family: 'FedraSansStd-medium';
            position: relative;
          }
        `}
      </style>
    </Box>
  );
};

export default EnlightenmentFourRow;
